import { ApiClient } from '@travel/api-client';

import { ProviderDetails } from 'ProviderDetails-Types';
import { MONTEROSA_API_TIMEOUT } from 'store/utils';

export const fetchProviderDetails = (
  http: ApiClient,
  id: string,
  ipAddress?: string,
): Promise<ProviderDetails> => {
  const headers = ipAddress ? { 'trv-client-ip': ipAddress } : undefined;
  return http.post(`/monterosa-api-dp/dp/jrdp/provider-details/`, {
    values: { id },
    timeout: MONTEROSA_API_TIMEOUT,
    headers,
  });
};
